import { ScheduleStatus, } from '@wix/ambassador-services-catalog-server/types';
import { PaymentType, } from '@wix/bookings-uou-types';
export function oneTimePricing(paymentOptions, rate) {
    const paymentFromRate = mapPaymentFromRate(rate, paymentOptions);
    return {
        isFree: paymentFromRate.isFree,
        priceText: paymentFromRate.priceText,
        paymentType: paymentFromRate.paymentType,
        currency: paymentFromRate.currency,
        price: paymentFromRate.price,
        deposit: paymentFromRate.minCharge,
        isVariedPricing: paymentFromRate.isVariedPricing,
    };
}
export function mapServicePaymentDto(serviceResponse) {
    const rate = serviceResponse.schedules.find((serviceSchedule) => serviceSchedule.status === ScheduleStatus.CREATED).rate;
    const { isFree, priceText, paymentType, currency, price, deposit, isVariedPricing, } = oneTimePricing(serviceResponse.service.paymentOptions, rate);
    const minPrice = serviceResponse.minPrice
        ? mapServiceMoneyDto(serviceResponse.minPrice)
        : undefined;
    const maxPrice = serviceResponse.maxPrice
        ? mapServiceMoneyDto(serviceResponse.maxPrice)
        : undefined;
    return {
        currency,
        price,
        isFree,
        priceText,
        minCharge: deposit,
        paymentType,
        isVariedPricing,
        minPrice,
        maxPrice,
    };
}
export const mapServiceMoneyDto = (money) => {
    return {
        currency: money.currency,
        price: Number(money.value),
        formattedValue: money.formattedValue,
    };
};
export function mapPaymentOptionsToPaymentType(paymentOptions) {
    if (paymentOptions.wixPayOnline && !paymentOptions.wixPayInPerson) {
        return PaymentType.ONLINE;
    }
    if (!paymentOptions.wixPayOnline && paymentOptions.wixPayInPerson) {
        return PaymentType.OFFLINE;
    }
    return PaymentType.BOTH;
}
export function mapPaymentFromRate(rate, paymentOptions) {
    let currency = null, price = 0, minCharge = 0, isVariedPricing = false;
    const priceText = rate?.priceText;
    if (rate?.labeledPriceOptions?.general) {
        currency = rate.labeledPriceOptions.general.currency;
        price = Number(rate.labeledPriceOptions.general.amount);
        minCharge = Number(rate.labeledPriceOptions.general.downPayAmount);
    }
    if (rate?.defaultVariedPrice) {
        isVariedPricing = true;
        currency = rate.defaultVariedPrice.currency;
        price = Number(rate.defaultVariedPrice.amount);
        minCharge = Number(rate.defaultVariedPrice.downPayAmount);
    }
    const isFree = isFreeService(paymentOptions, price);
    price = isFree ? 0 : price;
    const paymentType = paymentOptions && !isFree
        ? mapPaymentOptionsToPaymentType(paymentOptions)
        : PaymentType.OFFLINE;
    return {
        isFree,
        priceText,
        paymentType,
        currency,
        price,
        minCharge,
        isVariedPricing,
    };
}
export function isFreeService(paymentOptions, price) {
    return !!paymentOptions?.custom || (!price && !paymentOptions?.wixPaidPlan);
}
//# sourceMappingURL=service-payment.mapper.js.map